import { defineStyles } from "@pandacss/dev";

const buttonBaseStyles = defineStyles({
  borderWidth: "m",
  borderStyle: "solid",
  borderColor: "transparent",
  boxSizing: "border-box",
  display: "flex",
  gap: "gap.2",
  placeContent: "center",
  placeItems: "center",
  borderRadius: "l",
  paddingY: "10px",
  paddingX: "padding.4",
  textStyle: "title.s",
  width: "fit-content",
  textDecoration: "none",
  cursor: {
    base: "pointer",
    _disabled: "default",
  },
  _focusVisible: {
    shadow: "effect.focus-ring.brand",
    outline: "none",
    borderColor: "border.brand-bold",
    _withinWhiteLabelTheme: {
      borderColor: "border.brand.brand-brand",
    },
  },
  _aromaticonChildren: {
    fontSize: "20px",
  },
});

export default buttonBaseStyles;
